"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeGroupDirection = void 0;
/**
 * {@docCategory ResizeGroup}
 */
var ResizeGroupDirection;
(function (ResizeGroupDirection) {
    ResizeGroupDirection[ResizeGroupDirection["horizontal"] = 0] = "horizontal";
    ResizeGroupDirection[ResizeGroupDirection["vertical"] = 1] = "vertical";
})(ResizeGroupDirection = exports.ResizeGroupDirection || (exports.ResizeGroupDirection = {}));
//# sourceMappingURL=ResizeGroup.types.js.map